var _excluded = ["rangeClassName", "embedded", "noDivider", "className", "onButtonClick"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import { Button, Separator } from '@domain-group/fe-co-allhomes-design-system';
import AllhomesRangeSelector from './allhomes-range-selector';
import rangeType from './range-type';
import * as styles from './allhomes-search-property-features.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var AllhomesSearchPropertyFeatures = _ref => {
  var rangeClassName = _ref.rangeClassName,
    embedded = _ref.embedded,
    noDivider = _ref.noDivider,
    className = _ref.className,
    onButtonClick = _ref.onButtonClick,
    props = _objectWithoutProperties(_ref, _excluded);
  var beds = props.beds,
    baths = props.baths,
    parking = props.parking;
  var onSelectionChange = field => newRange => {
    var oldProps = {
      beds,
      baths,
      parking
    };
    var newProps = _objectSpread(_objectSpread({}, oldProps), {}, {
      [field]: newRange
    });
    props.onSelectionChange(newProps);
  };
  var renderSelector = (title, selector) => ___EmotionJSX("div", {
    css: styles.selectorWrapper
  }, ___EmotionJSX(AllhomesRangeSelector, {
    className: rangeClassName,
    name: title,
    selectedRange: props[selector],
    max: props["".concat(selector, "Max")],
    onChange: onSelectionChange(selector)
  }));
  return ___EmotionJSX("section", {
    className: className,
    css: styles.propertyFeatures(embedded)
  }, renderSelector('Bedrooms', 'beds'), ___EmotionJSX(Separator, {
    css: styles.divider({
      noDivider
    })
  }), renderSelector('Bathrooms', 'baths'), ___EmotionJSX(Separator, {
    css: styles.divider({
      noDivider
    })
  }), renderSelector('Parking', 'parking'), !embedded && ___EmotionJSX(Separator, {
    css: styles.divider({
      noDivider
    })
  }), !embedded && ___EmotionJSX(Button, {
    onClick: onButtonClick
  }, "Apply"));
};
AllhomesSearchPropertyFeatures.propTypes = {
  onButtonClick: PropTypes.func,
  onSelectionChange: PropTypes.func,
  beds: rangeType,
  baths: rangeType,
  parking: rangeType,
  bedsMax: PropTypes.number,
  // eslint-disable-line react/no-unused-prop-types
  bathsMax: PropTypes.number,
  // eslint-disable-line react/no-unused-prop-types
  parkingMax: PropTypes.number,
  // eslint-disable-line react/no-unused-prop-types
  className: PropTypes.string,
  rangeClassName: PropTypes.string,
  embedded: PropTypes.bool,
  noDivider: PropTypes.bool
};
AllhomesSearchPropertyFeatures.defaultProps = {
  onButtonClick: () => {},
  onSelectionChange: () => {},
  beds: {},
  baths: {},
  parking: {},
  bedsMax: 5,
  bathsMax: 5,
  parkingMax: 5,
  className: undefined,
  rangeClassName: undefined,
  embedded: false,
  noDivider: false
};
export default AllhomesSearchPropertyFeatures;